/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useState, useEffect } from 'react';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import DescriptionModal from '../../../../../components/DescriptionModal';
import { ConvertToTitleCase } from '../../../../../CommonMethods/ConvertToTitleCase';
import TextSection from '../../../../../components/ToolTip/TextSection';
import FromatDateString from '../../../../../CommonMethods/FromatDateString';
// Add this import at the top with other imports
import { useNavigate } from 'react-router-dom';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import moment from 'moment';

const TableBody = ({
    tableData, 
    indexNum, 
    selectedIndex, 
    setSelectedIndex,
    getBranch, 
    selectedRef, 
    searchParams,
    lastIndex }) => {
    
    const {setToastErrorMessage, setToastmessage, isInactiveBranch} = useContext(GlobalContext);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [activateOpen, setActivateOpen] = useState(false);
    const [statusSelection, setstatusSelection] = useState('');
    const [hover, sethover] = useState(false)
    const [descriptionModal, setDescriptionModal] = useState(false);
    const [expandedSegments, setExpandedSegments] = useState({});
    const [firstSegmentExpanded, setFirstSegmentExpanded] = useState(false);
    const [secondSegmentExpanded, setSecondSegmentExpanded] = useState(false);
    const navigate = useNavigate();
    /**
     * The function `handleActivateOpen` sets the state variable `activateOpen` to `true`.
     */
    const handleActivateOpen = () => {
        setActivateOpen(true)
    }
    /**
     * The function `handleOnCLickActivate` is an asynchronous function that handles the activation or
     * deactivation of a group or ledger in a React application.
     */
    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            let body = {};
            // Use the statusSelection directly for the status
            body = {
                "status": statusSelection
            };
            
            let endpoint = `groups-and-ledgers/${tableData._id}`;
            const response = await dataService.PatchAPI(body, endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastmessage(`${ConvertToTitleCase(tableData.type)} ${statusSelection === 'active' ? 'activated' : 'deactivated'} successfully`);
            getBranch();
        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false); 
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
            console.error(error);
        }
    }
    /**
     * The function handleConformationClick sets the state variable activateOpen to false.
     */
    const handleConformationClick = () => {
        setActivateOpen(false)
    }

    /**
     * The function `handelActionButton` sets the selected index to the provided index number.
     */
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
    }
 
    /* The `statusObj` constant is an object that stores different properties for different status
    values. It is used to determine the background color, image source, and key value for each
    status value. */
    const statusObj={
        'active':{
            bg:'bg-[#C5FFD5]',
            img:'/images/successDot.svg',
            key:'activate'
        },
        'inactive':{
            bg:'bg-[#B3BBC1]',
            img:'/images/inactive-Dot.svg',
            key:'deactivate'

        },
        'draft':{
            bg:'bg-[#FFEEB0]',
            img:'/images/draft-img.svg'
        }
    }
    const [expandedGroups, setExpandedGroups] = useState({});
    const [breadcrumbPath, setBreadcrumbPath] = useState('');
    const [showBreadcrumb, setShowBreadcrumb] = useState(false);
    const [breadcrumbData, setBreadcrumbData] = useState(null);
    const [childrenData, setChildrenData] = useState(null);
    const [firstSegment, setFirstSegement] = useState()
    const [secondSegment, setSecondSegemnt] = useState()
    const [segment, setSegment] = useState([])
    const [hasLevel2Child, setHasLevel2Child]= useState(false)

    const toggleBreadcrumb = (id) => {
        setShowBreadcrumb(!showBreadcrumb);
        fetchChildrenData(id);
        setFirstSegmentExpanded(true);
        setSecondSegmentExpanded(true);
        if (!showBreadcrumb) {
            fetchChildrenData();
        } else {
            setExpandedGroups({});
            setChildrenData(null);
        }
    };

    const toggleGroup = (groupId) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupId]: !prev[groupId]
        }));
    };

    console.log(expandedGroups)

    const renderBreadcrumbHeader = () => (
        <tr className="bg-[#e7e7e7] cursor-pointer" >
            <td colSpan={2} className="py-2 px-4">
                <div className="flex items-center justify-between" onClick={()=> toggleBreadcrumb(tableData?._id)}>
                    <div className="flex items-center gap-2 w-[60%]  ">
                        <img 
                            src={showBreadcrumb ? "/images/down-arrow.svg" : "/images/right-arrow.svg"} 
                            alt="arrow" 
                            className="w-4 h-4"
                            
                        />
                        <span className="">
                            {tableData.parent_group_name_composite_key || tableData.group_name}
                        </span>
                    </div>
                    <div className='w-[28%]  text-center'>
                        <span className="">
                            {(tableData.group_type === 'PL' ? 'P&L' :'BS') || 'PL'}
                        </span>
                    </div>
                </div>
            </td>
        </tr>
    );

    useEffect(() => {
        fetchBreadcrumbData();
        // fetchChildrenData();
    }, []);

    const fetchBreadcrumbData = async () => {
        try {
            setBreadcrumbData({
                _id: tableData._id,
                group_name: tableData.group_name,
                parent_group_path: tableData.parent_group_name_composite_key,
                group_type: tableData.group_type || 'PL'
            });
            const fullPath = tableData?.parent_group_name_composite_key;
            const segments = fullPath.split(' > ')
            setSegment(segments)

            setFirstSegement(segments[0])
            setSecondSegemnt(segments[1])
        } catch (error) {
            console.error('Error setting breadcrumb data:', error);
        }
    };
    
    const fetchChildrenData = async (id) => {
        try {
            const branch_id = await GetBranchId();
            let endpoint = `groups-and-ledgers/group-details?_id=${id}&branch_id=${branch_id}`;
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.parent_groups;
            setChildrenData(temp);
            if (temp.length > 0) {
                setHasLevel2Child(true);
            }
            let expanded = {};
            console.log('grosdflklsd',temp)
            const expandAll = (groups, segment) => {
                groups.forEach((group) => {
                    const groupId = group.name;
                    console.log('grouppppppp',groupId,segment)

                    if (segment.includes(group.name)) {
                        expanded[groupId] = true;
                        console.log(true,groupId)
                    }

                    if (group.has_child && group.items.length > 0) {
                        expandAll(group.items, segment);
                    }
                });
            };
            console.log('expanded',expanded)

            expandAll(temp,segment);
            setExpandedGroups(expanded); // 
        } catch (error) {
            console.error('Error fetching children data:', error);
        }
    };
    // const toggleSegment = async (group, level) => {
    //     const groupId = group.ledger_id || group._id || group.name;

    //     if (expandedSegments[groupId]) {
    //         setExpandedSegments(prev => {
    //             const newExpanded = { ...prev };
    //             delete newExpanded[groupId];
    //             return newExpanded;
    //         });
    //     } else {
    //     // Expand this segment
    //         if (group.has_child) {
    //             if (!group.children && group.name_type === 'group') {
    //                 const branch_id = await GetBranchId();
    //                 const response = await dataService.GetAPI(
    //                     `groups-and-ledgers/group-details?_id=${groupId}&branch_id=${branch_id}`
    //                 );

    //                 group.children = response?.data?.data?.parent_groups || [];
    //             }

    //             setExpandedSegments(prev => ({
    //                 ...prev,
    //                 [groupId]: true
    //             }));
    //         }
    //     }
    // }


    const renderGroupRow = (group, level = 0) => {
        let groupId =
        group?.ledger_id || group?._id || group?.name || `level-${level}`;
        let displayName = "";

        if (level === 1) {
            displayName = firstSegment;
            groupId = "firstSegment";
        } else if (level === 2) {
            displayName = secondSegment;
            groupId = "secondSegment";
        } else if (level > 2) {
            displayName = group?.group_name || group?.name || "";
        }
        console.log('expandeddddddddd',expandedSegments)

        return (
            <tr className="hover:bg-[#F5F5F5]" key={groupId}>
                <td className="text-start py-1 bg-gray-100 w-full" colSpan="2" style={{border:"none"}}>
                    <div
                        className="flex items-center justify-between w-full"
                        style={{ paddingLeft: `${(level + 1) * 24}px` }}
                    >
                        <div className="flex items-center">
                            {/* Show expand icon if expandable */}
                            {level === 1 || (level === 2 && hasLevel2Child) || (level >= 3 && (group?.has_child || group?.children?.length)) ? (
                                <button
                                    onClick={() => {
                                        if (level === 1) {
                                            setFirstSegmentExpanded((prev) => !prev);
                                        } else if (level === 2) {
                                            setSecondSegmentExpanded((prev) => !prev);
                                        } else {
                                            toggleGroup(groupId);
                                        }
                                    }}
                                    className="prevent-click mr-2"
                                >
                                    <img
                                        src={(level === 1 && firstSegmentExpanded) ||(level === 2 && secondSegmentExpanded) ||(level > 2 && expandedGroups[groupId])
                                            ? "/images/down-arrow.svg"
                                            : "/images/right-arrow.svg"
                                        }
                                        alt="toggle"
                                        className="w-4 h-4"
                                    />
                                </button>
                            ) : (
                                <span className="inline-block w-4 h-4 mr-2"></span>
                            )}
                        
                            <span className={`text-sm ${level <= 2 ? "font-medium" : ""}`}>
                                {displayName}
                            </span>
                        </div>
                        {level === 1 && !tableData.is_default  && (
                            <div className="text-xs text-gray-500 xl:w-[15rem] 2xl:w-[20rem]">
                                Added on {tableData.created_at ? `${moment(tableData.created_at).format('MMM DD, YYYY')} by ${tableData.created_by}` : '-'}
                            </div>
                        )}
                    </div>
                </td>
            </tr>
        );
    };

    const renderChildren = (group, level) => {
        console.log('group',group)
        if (level < 2 || !secondSegmentExpanded) return null;

        const children = group?.items || [];
        const groupId = group?.ledger_id || group?._id || group?.name;

        console.log('children', children)
        console.log('groupId', groupId)
        console.log('expandedSegments',expandedGroups)
        if (!expandedGroups[groupId]) return null;

        return children.map((child) => (
            <React.Fragment key={child.ledger_id || child._id || child.name}>
                {renderGroupRow(child, level + 1)}
                {renderChildren(child, level + 1)}
            </React.Fragment>
        ));
    };

    return (
        <>
            {searchParams.get('type') === 'group' ? (
                <>
                    {renderBreadcrumbHeader()}

                    {/* First segment */}
                    {showBreadcrumb && <>{ renderGroupRow(null, 1)}

                        {/* Second segment if first is expanded */}
                        {firstSegmentExpanded && renderGroupRow(null, 2)}

                        {/* Actual children if second is expanded */}
                        {firstSegmentExpanded && secondSegmentExpanded && childrenData?.map(group => (
                        
                            <React.Fragment key={group.ledger_id || group._id || group.name}>
                                {renderGroupRow(group, 3)}
                                {renderChildren(group, 3)}
                            </React.Fragment>
                        ))}</>}
                    
                </>
            ) : (
                <tr 
                    className={`${tableData?.status ? '' : 'inactive'}`}
                    onClick={(e) => {
                        if (e.target.closest('.prevent-click')) {
                            e.stopPropagation();
                            return;
                        }
                        if (tableData.type === 'ledger') {
                            navigate(`/main-hub/groups-ledgers/ledger-details/${tableData._id}?${searchParams.toString()}`);
                        }
                    }}
                    style={{ cursor: tableData.type === 'ledger' ? 'pointer' : 'default' }}
                >
                    {(searchParams.get('type')==null || searchParams.get('type')=='ledger')&&
                        <td 
                            className="text-start" 
                            onClick={(e) => {
                                e.stopPropagation();
                                // Forward the click to the parent row
                                e.currentTarget.parentElement?.click();
                            }}
                        >
                            {tableData?.ledger_name || '-'}
                        </td>
                    }
                    <td 
                        className="relative prevent-click" 
                        onMouseEnter={()=>sethover(true)} 
                        onMouseLeave={()=>sethover(false)}
                        onClick={(e) => {
                            e.stopPropagation();
                            // Forward the click to the parent row
                            e.currentTarget.parentElement?.click();
                        }}
                    >
                        <span className=''>{tableData.type==='ledger'?tableData?.parent_group_path:tableData?.parent_group_name_composite_key}</span>
                    </td>
                    <td 
                        className="table-cell prevent-click"
                        onClick={(e) => {
                            e.stopPropagation();
                            // Forward the click to the parent row
                            e.currentTarget.parentElement?.click();
                        }}
                    >
                        <div className='flex justify-center'>
                            <div class={`w-fit rounded flex items-center justify-center py-1 ${statusObj[tableData?.status]?.bg} px-2.5`}>
                                <img loading="lazy" decoding="async" src={statusObj[tableData?.status]?.img} alt="icon"/>
                                <span class="text-f7 font-normal text-[#031624] pl-1 capitalize">{tableData?.status}</span>
                            </div>
                        </div>
                    </td>
                    <td 
                        className="text-center"
                        onClick={(e) => {
                            e.stopPropagation();
                            // Forward the click to the parent row
                            e.currentTarget.parentElement?.click();
                        }}
                    >
                        <div className="relative flex items-center justify-center" data-te-dropdown-ref>
                            <button type='button' 
                                className={`focus:bg-[#95C0E0] cursor-pointer list-more-btn prevent-click`} 
                                href="#"
                                id={tableData.email_address}
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent click from bubbling to parent
                                    e.preventDefault(); // Prevent default behavior
                                    handelActionButton(indexNum);
                                }}
                                data-te-dropdown-toggle-ref
                                aria-expanded="false"
                                data-te-ripple-init
                                data-te-ripple-color="light">
                                <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" />
                            </button>
                            {selectedIndex === indexNum && <ul ref={selectedRef} className={`${(indexNum+1 === 10 || indexNum+2 === 10) ? 'top3' : ''}  list-more-optns-div [&[data-te-dropdown-show]]:block`}
                                aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                {<>
                                    {
                                        <li onClick={() => {
                                            setSelectedIndex(null);
                                            const role = "groups-ledgers";
                                            navigate(`/main-hub/groups-ledgers/ledger-details/${tableData._id}?${searchParams.toString()}`);
                                        }}>
                                            <AnimatedButton 
                                                handleClick={() => {}}
                                                buttonName="View Details"
                                                className="list-more-optns prevent-click"
                                            />
                                        </li>   
                                    }
                                    {!isInactiveBranch && tableData?.is_autocreated != true &&
                                        <>
                                            {tableData?.status === 'draft' && 
                                            <li onClick={()=>setstatusSelection('active')}>
                                                <AnimatedButton 
                                                    handleClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        setSelectedIndex(null);
                                                        setstatusSelection('active');
                                                        handleActivateOpen();
                                                        return false;
                                                    }} 
                                                    buttonName={`Activate`}
                                                    className="list-more-optns prevent-click"/>
                                            </li>}
                                            {tableData?.status !== 'inactive' && !tableData.is_default &&
                                            <li onClick={()=>setstatusSelection('inactive')}>
                                                <AnimatedButton 
                                                    handleClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        setSelectedIndex(null);
                                                        setstatusSelection('inactive');
                                                        handleActivateOpen();
                                                        return false;
                                                    }} 
                                                    buttonName={`Deactivate`}
                                                    className="list-more-optns prevent-click"/>
                                            </li>
                                            }
                                        
                                        </>}
                                </>}
                            </ul>}
                        </div>
                    </td>
                </tr>
            )}
            {activateOpen && (
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleOnCLickActivate}
                            handleClose={handleConformationClick}
                            tittle={`${ConvertToTitleCase(statusObj[statusSelection].key)} Ledger`}
                            additionalMessage={statusObj[statusSelection].key === 'activate' ? '' : 'Once the ledger is deactivated, it cannot be activated.'}
                            message={statusObj[statusSelection].key === 'activate' ? `Are you sure you want to ${statusObj[statusSelection].key} the ledger '${tableData.ledger_name}' ?` : `Are you sure you want to deactivate the ledger '${tableData.ledger_name}' ?`}
                            buttonName={`${ConvertToTitleCase(statusObj[statusSelection].key)}`}
                            dialogueWidth={statusObj[statusSelection].key === 'activate' ? '' : '500px'}
                            textPosition={statusObj[statusSelection].key === 'activate' ? '' : 'text-start'}
                            loadingActivation={activateButtonLoading}
                        />
                    }
                />
            )}
            {descriptionModal && (
                <DescriptionModal 
                    descriptionModal={descriptionModal}
                    setDescriptionModal={setDescriptionModal}
                    description={tableData.description}
                />
            )}
        </>
    );
}



export default TableBody;
